import {gql} from 'apollo-angular';
import {baseResponseGraphqlField} from '../../../base.graphql';

export const freeServicesSummariesField = `
id
serviceUniqueId
serviceIsSubService
serviceName
serviceIsApproved
serviceDescription
serviceHasSubService
serviceHasCoProviders
serviceCoProviders {
  id
  coproviderUniqueId
  coproviderCollaborationPurpose
  coproviderInstitution {
    id
    institutionUniqueId
    institutionName
    institutionShortform
    institutionPhysicalAddress
    institutionEmail
    institutionPostcode
    institutionWebsite
    institutionPhones
    institutionMapUrl
  }
}
serviceHasOpponents
serviceGroups {
  id
  groupUniqueId
  groupType
}
serviceCategory {
  id
  categoryUniqueId
  categoryName
  categoryDescription
}
serviceOpponents {
  id
  opponentUniqueId
  opponentInstitution {
    id
    institutionUniqueId
    institutionName
    institutionShortform
    institutionPhysicalAddress
    institutionEmail
    institutionPostcode
    institutionWebsite
    institutionPhones
    institutionMapUrl
  }
}
serviceResults {
  id
  resultUniqueId
  resultDescription
}
serviceProvider {
  id
  institutionUniqueId
  institutionName
  institutionShortform
  institutionPhysicalAddress
  institutionEmail
  institutionPostcode
  institutionWebsite
  institutionPhones
  institutionMapUrl
  institutionMinistry {
    id
    ministryUniqueId
    ministryName
  }
  institutionSector {
    id
    sectorUniqueId
    sectorName
    sectorIcon
  }
}
numberOfServices
`;

export const GET_FREE_SERVICES_SUMMARIES = gql`
query citizenGetFreeServicesSummaries{
    citizenGetFreeServicesSummaries{
    ${baseResponseGraphqlField}
    data {
      ${freeServicesSummariesField}
    }
  }
}
`;
